import _ from 'lodash';

export default groupByApptStatus;

/**
 * @name groupByApptStatus
 * @description Group appointments by status
 * @param {array} collection The collection of appointments to group
 * @return {array} groupedAppointments Returns the grouped collection
 */
function groupByApptStatus(collection) {
  let groupedCollection;
  if (collection[0].appointment) {
    groupedCollection = _.groupBy(collection, function(object) {
      if (!_.isUndefined(object.appointment) &&
      !_.isUndefined(object.appointment.last_status)) {
        return _.camelCase(object.appointment.last_status.status_name);
      }
      return 'noAppointments';
    });
  } else {
    groupedCollection = _.groupBy(collection, function(appointment) {
      if (!_.isUndefined(appointment) &&
      !_.isUndefined(appointment.last_status)) {
        return _.camelCase(appointment.last_status.status_name);
      }
      return 'noAppointments';
    });
  }
  return groupedCollection;
}



// WEBPACK FOOTER //
// ./utils/group-by-appt-status.js